var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:( _obj = {}, _obj[("theme--" + _vm.themeVar)] = true, _obj.mobile = _vm.isMobile, _obj.desktop = _vm.isDesktop, _obj )},[(_vm.isOnboarding)?_c('layout-onboarding'):_c('layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }